import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as CheckedIcon } from '../../svg/checked.svg';
import { ReactComponent as ArrowsIcon } from '../../svg/arrows.svg';

import styles from './Select.module.css';
import useOutsideClick from '../../hooks/useOutsideClick';
import { getFormattedBalance } from '../../helpers/index';

function Select({ items, activeItem, onSelect, withImage, labelElement }) {
  const wrapperRef = useRef(null);
  const { clickedOutside } = useOutsideClick(wrapperRef);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (clickedOutside) {
      setIsOpen(false);
    }
  }, [clickedOutside]);

  return (
    <div
      ref={wrapperRef}
      className={classNames(styles.wrapper, { [styles.active]: isOpen })}
      onClick={() => {
        (items.length > 1) && setIsOpen((state) => !state);
      }}
    >
      {withImage && (
        <img className={styles.img} src={`/${activeItem.name}.svg`} width="16" height="16" alt={activeItem.name} />
      )}
      {labelElement ? (
        labelElement
      ) : (
        <span className={styles.activeElement}>
          {activeItem.alias}
        </span>
      )}
      {items.length > 1 && (
        <div className={styles.icon}>
          <ArrowsIcon />
        </div>
      )}
      {isOpen && (
        <div className={styles.dd}>
          {items
            .map(({alias, name, total}, index) => {
              return (
                <div
                  className={classNames(styles.item, {
                    [styles['with-image']]: withImage,
                    [styles['active']]: activeItem.name === name,
                  })}
                  key={index}
                  onClick={() => onSelect({name, alias})}
                >
                  {withImage && (
                    <img className={styles.img} src={`/${name}.svg`} width="16" height="16" alt="" />
                  )}{' '}
                  <span className={styles.total}>
                    <bdi>{getFormattedBalance(total)}</bdi>
                  </span>
                  <span>{name}</span>
                  {activeItem.name === name && <CheckedIcon />}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}

export default Select;
